import React from "react";
import Contact_form from "../contact-form";
import Contact_ways from "../contact-ways";

function Contact_content(){

    return(
        <div className="contact-content">
            <Contact_ways />
            <Contact_form />
        </div>
    );

}

export default Contact_content;